import request from '@/common/request'
export default {
  queryMonitorNotice: params => {
    return request({
      url: '/monitorNotice',
      method: 'get',
      params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/monitorNotice.js